import { gql } from '@apollo/client'
import { TypedDocumentNode } from '@graphql-typed-document-node/core'
import {
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutationVariables,
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutationVariables,
  FcFinSimpleGrowAccountUpdateGaragingAddressMutation,
  FcFinSimpleGrowAccountUpdateGaragingAddressMutationVariables,
  FcFinSimpleGrowCustomerUpdateBillingAddressMutation,
  FcFinSimpleGrowCustomerUpdateBillingAddressMutationVariables,
  FcFinSimpleGrowCustomerUpdateEmailsMutation,
  FcFinSimpleGrowCustomerUpdateEmailsMutationVariables,
  FcFinSimpleGrowCustomerUpdatePhonesMutation,
  FcFinSimpleGrowCustomerUpdatePhonesMutationVariables,
} from '@src/__generated__/graphql'

export const UPDATE_CUSTOMER_NOTIFICATIONS_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowCustomerUpdateNotificationPreferencesMutationVariables
> = gql`
  mutation FcFinSimpleGrowCustomerUpdateNotificationPreferences($input: fc__customer__NotificationPreferencesRequest!) {
    fc__customer__updateNotificationPreferences(input: $input) {
      success
      code
      message
    }
  }
`

export const UPDATE_ACCOUNT_NOTIFICATIONS_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutation,
  FcFinSimpleGrowAccountUpdateNotificationPreferencesMutationVariables
> = gql`
  mutation FcFinSimpleGrowAccountUpdateNotificationPreferences($input: fc__account__NotificationPreferencesRequest!) {
    fc__account__updateNotificationPreferences(input: $input) {
      success
      code
      message
    }
  }
`

export const UPDATE_EMAIL_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowCustomerUpdateEmailsMutation,
  FcFinSimpleGrowCustomerUpdateEmailsMutationVariables
> = gql`
  mutation FcFinSimpleGrowCustomerUpdateEmails($input: fmcc__customer__EmailRequest!) {
    fmcc__customer__updateEmails(input: $input) {
      success
      code
      message
    }
  }
`

export const UPDATE_BILLING_ADDRESS_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowCustomerUpdateBillingAddressMutation,
  FcFinSimpleGrowCustomerUpdateBillingAddressMutationVariables
> = gql`
  mutation FcFinSimpleGrowCustomerUpdateBillingAddress($input: fmcc__customer__BillingAddressRequest!) {
    fmcc__customer__updateBillingAddress(input: $input) {
      success
      code
      message
    }
  }
`

export const UPDATE_GARAGING_ADDRESS_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowAccountUpdateGaragingAddressMutation,
  FcFinSimpleGrowAccountUpdateGaragingAddressMutationVariables
> = gql`
  mutation FcFinSimpleGrowAccountUpdateGaragingAddress($input: fmcc__account__GaragingAddressRequest!) {
    fmcc__account__updateGaragingAddress(input: $input) {
      success
      code
      message
      garagingAddress {
        addressLine1
        addressLine2
        city
        state
        zip
        country
        lastModifiedDate
      }
    }
  }
`

export const UPDATE_PHONES_MUTATION: TypedDocumentNode<
  FcFinSimpleGrowCustomerUpdatePhonesMutation,
  FcFinSimpleGrowCustomerUpdatePhonesMutationVariables
> = gql`
  mutation FcFinSimpleGrowCustomerUpdatePhones($input: fmcc__customer__PhoneRequest!) {
    fmcc__customer__updatePhones(input: $input) {
      success
      code
      message
    }
  }
`
